/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import { useSelector } from "react-redux";
import { isInviteAcceptanceUrl } from "../utils/invitation";
import { selectAuthUser } from "../store/selectors";

/**
 * Redux `authData` is the only source of truth here. It is hydrated from
 * localStorage in init-state, so a reload starts with the stored user already
 * in the store and there is nothing to fall back to.
 *
 * Derived during render rather than mirrored into state from an effect. The
 * mirrored version recomputed only when the `authData` reference changed, so a
 * logout dispatched while `authData` was already null — exactly what an expired
 * session at bootstrap looks like, since forceLogout clears localStorage and
 * dispatches LOGOUT_SUCCESS into an already-null store — left this latched at
 * `true`. The router then read /login as "public page, user is logged in" and
 * bounced to /upload, which bounced to /company for the missing subscription,
 * whose requests 401'd straight back into forceLogout: a redirect loop that
 * only broke on a manual reload.
 */
const useAuthorized = () => {
  const authData = useSelector(selectAuthUser);

  if (isInviteAcceptanceUrl()) {
    return true;
  }

  return authData != null;
};

export default useAuthorized;
